export default __webpack_public_path__ + "static/media/ross.e15e2836.svg";